<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="WKSMenSuoFiles">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.pcOrder" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="createTime" align="center" label="创建时间"/>
      <el-table-column prop="techParamList" align="center" label="关联单号"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.WKSMenSuoFilePreview.open(scope.row.pkid)">预览</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <WKSMenSuoFilePreview ref="WKSMenSuoFilePreview" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import WKSMenSuoFilePreview from "@/views/purchase/WKSMenSuoFile/WKSMenSuoFilePreview";
  export default {
    name: "WKSMenSuoList",
    components: { VmTable, VmSearch,WKSMenSuoFilePreview},
    data() {
      return {
        constant,
        show: "",
        filter: {
          pcOrder:"",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","/baseCustomerPropertyValueMappings",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
